import { StorageKeys } from 'common/storage/constants';
import { QueryParams } from 'common/urls/QueryParams';
import { useState } from 'react';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { useLocalStorage } from 'src/shared/storage/Storage';
import { match } from 'ts-pattern';
import { StringParam, useQueryParam } from 'use-query-params';
import { RatingPercent } from '../constants';
import { ConsumerGroupOrderRatingModalContainer } from '../ConsumerGroupOrderRatingModal/ConsumerGroupOrderRatingModalContainer';
import { useInitialFoodItemRating } from '../useInitialFoodItemRating';
import { RateRecentGroupOrderModal } from './RateRecentGroupOrderModal';

type ModalType = 'rate-recent-group-order' | 'group-order-rating';

const MAX_PROMPTS_PER_GROUP_ORDER = 3;

export const RateRecentGroupOrderModalContainer = (): JSX.Element | null => {
  const [groupOrderIdFromQueryParam] = useQueryParam(QueryParams.RATE_PREV_GROUP_ORDER_ID, StringParam);
  const [currentUser] = useCurrentUser();
  const groupOrder = currentUser?.unratedGroupOrder;
  const key = `${StorageKeys.RATE_RECENT_GROUP_ORDER_KEY}-${groupOrder?.id}`;
  const [numViewsRateRecentGroupOrderModal, setHasSeenRateRecentGroupOrderModal] = useLocalStorage(key, 0);
  const [modalToShow, setModalToShow] = useState<ModalType | null>('rate-recent-group-order');
  const [, setInitialFoodItemRating] = useInitialFoodItemRating();
  const hasQueryParamForShowingGroupOrderRatingModal = !!groupOrderIdFromQueryParam;

  if (
    !groupOrder?.canReviewOrder ||
    numViewsRateRecentGroupOrderModal >= MAX_PROMPTS_PER_GROUP_ORDER ||
    hasQueryParamForShowingGroupOrderRatingModal
  ) {
    return null;
  }

  const handleHide = () => {
    setModalToShow(null);
    setHasSeenRateRecentGroupOrderModal(numViewsRateRecentGroupOrderModal + 1);
  };

  const handleRatingClick = ({ lineItemId, ratingPercent }: { lineItemId: number; ratingPercent: RatingPercent }) => {
    setInitialFoodItemRating({ ratingPercent, lineItemId });
    setModalToShow('group-order-rating');
  };

  return match(modalToShow)
    .with('rate-recent-group-order', () => (
      <RateRecentGroupOrderModal groupOrder={groupOrder} onClose={handleHide} onRatingClick={handleRatingClick} />
    ))
    .with('group-order-rating', () => (
      <ConsumerGroupOrderRatingModalContainer groupOrderId={groupOrder.id} hide={handleHide} />
    ))
    .with(null, () => null)
    .exhaustive();
};
